/** @jsx jsx */
import PropTypes from "prop-types";

import { jsx } from "theme-ui";
import React, { useCallback, useEffect, useMemo } from "react";
import {
  MessageBar,
  MessageBarType,
  Stack,
  StackItem,
} from "office-ui-fabric-react";
import renderPersonResult from "gatsby-plugin-hfn-profile/components/SrcmEntities/Render/renderPersonDetails";
import { get } from "sites-common/utils/lodash";
import {
  DynamicField,
  validateForm,
} from "@heartfulnessinstitute/react-hfn-forms/dist/DynamicForm";
import { aimsFlds, fldMap, visitFlds, formValidator } from "./fields";

const EditingRecord = ({
  id,
  people,
  setPeople,
  errors,
  setErrors,
  adminConfig,
}) => {
  const p = people[id];

  const formFields = [...aimsFlds(adminConfig), ...visitFlds(adminConfig)];

  const onChange = useCallback(
    (id1, key, val) => {
      setPeople((p1) => ({ ...p1, [id1]: { ...p1[id1], [key]: val } }));
    },
    [setPeople]
  );
  const onMultiSelect = useCallback(
    (id1, key, val) => {
      setPeople((p1) => ({
        ...p1,
        [id1]: {
          ...p1[id1],
          [key]: p1[id1][key]?.includes(val)
            ? p1[id1][key].filter((v) => v !== val)
            : [...(p1[id1][key] || []), val],
        },
      }));
    },
    [setPeople]
  );

  useEffect(() => {
    const errors1 = validateForm(
      [...aimsFlds(adminConfig), ...visitFlds(adminConfig)],
      formValidator(adminConfig),
      {},
      p
    );

    setErrors((prev) => ({ ...prev, [id]: errors1 }));
  }, [p, setErrors, id, adminConfig]);

  const fMap = useMemo(() => fldMap(adminConfig), [adminConfig]);

  return (
    <React.Fragment>
      <Stack>
        <StackItem>{renderPersonResult(p, true)}</StackItem>
      </Stack>
      <div
        sx={{
          bg: "white",
          border: "solid 1px lightblue",
          px: 2,
          pb: 2,
          ml: 4,
          my: 2,
        }}
      >
        {fMap.map((row) => (
          <Stack horizontal tokens={{ childrenGap: 4 }}>
            {row.map((col) => {
              const f = formFields.filter((r) => r.name === col)[0];

              return (
                <StackItem grow>
                  {!f.hide && (
                    <DynamicField
                      {...f}
                      value={get(p, f.name) || ""}
                      onChange={(val) => {
                        if (f.type === "multiselect") {
                          onMultiSelect(id, f.name, val);
                        } else {
                          onChange(id, f.name, val);
                        }
                      }}
                    />
                  )}
                </StackItem>
              );
            })}
          </Stack>
        ))}

        {get(errors, id, null) && (
          <MessageBar
            messageBarType={MessageBarType.error}
            sx={{ mt: 1, fontSize: "0.8rem" }}
          >
            <div dangerouslySetInnerHTML={{ __html: errors[id] }} />
          </MessageBar>
        )}
      </div>
    </React.Fragment>
  );
};

EditingRecord.propTypes = {
  id: PropTypes.string.isRequired,
  people: PropTypes.shape({}).isRequired,
  setPeople: PropTypes.func.isRequired,
  errors: PropTypes.shape({}).isRequired,
  setErrors: PropTypes.func.isRequired,
  adminConfig: PropTypes.shape({}).isRequired,
};

export default EditingRecord;
